<script lang="ts" setup>
import { ref } from 'vue';
import ProgressSteps from './ProgressStepsTrack.vue';
import ProgressStepsOverlay from './ProgressStepsOverlay.vue';

const showOverlay = ref(false);
const toggleOverlay = () => {
  showOverlay.value = !showOverlay.value;
};
</script>

<template>
  <ProgressSteps @click="toggleOverlay" />
  <ProgressStepsOverlay v-model:visible="showOverlay" />
</template>

<style lang="less" scoped></style>
